import type { SettingTab } from '@/lib/configs/setting-config'

export const DEFAULT_SETTINGS_RETURN_TO = '/trade'

export function sanitizeSettingsReturnTo(value: string | null | undefined): string {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) {
    return DEFAULT_SETTINGS_RETURN_TO
  }

  try {
    const url = new URL(value, 'https://orderx.local')
    if (
      url.origin !== 'https://orderx.local' ||
      url.pathname === '/settings' ||
      url.pathname.startsWith('/settings/')
    ) {
      return DEFAULT_SETTINGS_RETURN_TO
    }

    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return DEFAULT_SETTINGS_RETURN_TO
  }
}

export function resolveSettingsEntryReturnTo(pathname: string, search = ''): string {
  const normalizedSearch = search.startsWith('?') ? search.slice(1) : search

  if (pathname === '/settings' || pathname.startsWith('/settings/')) {
    return sanitizeSettingsReturnTo(new URLSearchParams(normalizedSearch).get('returnTo'))
  }

  return sanitizeSettingsReturnTo(`${pathname}${normalizedSearch ? `?${normalizedSearch}` : ''}`)
}

export function buildSettingsPathname(tab: SettingTab): string {
  return `/settings/${tab.toLowerCase()}`
}

export function buildSettingsPath(tab: SettingTab, returnTo: string): string {
  const params = new URLSearchParams({ returnTo: sanitizeSettingsReturnTo(returnTo) })
  return `${buildSettingsPathname(tab)}?${params.toString()}`
}
